// Copied from https://github.com/svenheden/swedish-personal-identity-number-validator/blob/master/index.ts

const pattern = /^\d{6}(\d{2})?[+-]?\d{4}$/;

const hasCorrectChecksum = (input: string) => {
  const sum = input
    .split('')
    .reverse()
    .map(Number)
    .map((x, i) => (i % 2 ? x * 2 : x))
    .map((x) => (x > 9 ? x - 9 : x))
    .reduce((x, y) => x + y);

  return sum % 10 === 0;
};

const hasValidDate = (input: string) => {
  const regex = /^(\d{4})(\d{2})(\d{2})/;
  const [, yearStr, monthStr, dayStr] = regex.exec(input) || [];

  const year = Number(yearStr);
  const month = Number(monthStr) - 1;
  let day = Number(dayStr);

  if (day > 60) {
    // coordination numbers ("samordningsnummer")
    day -= 60;
  }

  const date = new Date(year, month, day);

  if (
    year < 1900 ||
    year > new Date().getFullYear() ||
    date.getFullYear() !== year ||
    date.getMonth() !== month ||
    date.getDate() !== day
  ) {
    return false;
  }

  return true;
};

function hasValidFormat(pnr: string): boolean {
  const regex = /^\d{12}$/;
  return regex.test(pnr);
}

function hasCorrectBirthNumber(pnr: string) {
  const regex = /000.$/;
  return !regex.test(pnr);
}

export const validateSwedishPnr = (ssn: string) => {
  if (!pattern.test(ssn)) {
    return false;
  }

  const sanitized = ssn.replace(/[+-]/, '');
  const shortPnr = sanitized.slice(-10);

  if (
    hasValidFormat(sanitized) &&
    hasCorrectChecksum(shortPnr) &&
    hasValidDate(sanitized) &&
    hasCorrectBirthNumber(sanitized)
  ) {
    return true;
  }

  return false;
};
